import React from 'react';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import EditChunkOptions from './EditChunkOptions';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import styles from './ChunkCard.module.css';
import Lottie from 'lottie-react';
import {loadingLottie} from '../../../assets/lottie';

type VisualState = 'normal' | 'selected' | 'dimmed';

interface Props {
  chunk: GeneratedVideoChunk;
  state: VisualState;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  onSelectChunk: (chunkId: string) => void;
  pixelsPerSecond: number;
  dragHandleProps?: React.HTMLAttributes<HTMLElement>;
}

const ChunkCard: React.FC<Props> = ({
  chunk,
  state = 'normal',
  onEditChunk,
  onSelectChunk,
  pixelsPerSecond,
  dragHandleProps,
}) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const getStateStyle = (state: string) => {
    switch (state) {
      case 'selected':
        return styles.selected;
      case 'dimmed':
        return styles.dimmed;
      case 'normal':
      default:
        return styles.normal;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).closest('[data-no-select]')) return;
    onSelectChunk(chunk.id);
  };

  const width = pixelsPerSecond * chunk.duration;
  const isTiny = width < 40;
  return (
    <div
      style={{width: `${width}px`}}
      className={`${styles.chunkCardContainer} ${getStateStyle(state)} ${
        isTiny ? styles.tinyChunk : ''
      }`}
      onClick={handleClick}>
      <div className={styles.dragHandle} {...dragHandleProps}>
        ⠿
      </div>
      <EditChunkOptions
        chunk={chunk}
        onEditChunk={onEditChunk}
        isTiny={isTiny}
      />
      <div className={styles.chunkDuration}>
        {Math.round(chunk.duration) + 's'}
      </div>
      {isLoading && (
        <Lottie
          animationData={loadingLottie}
          loop={true}
          style={{width: '34px', height: '34px'}}
        />
      )}
      <video
        src={chunk.uri}
        width={width}
        height={100}
        onLoadedData={() => setIsLoading(false)}
        style={{display: isLoading ? 'none' : 'block'}}
      />
    </div>
  );
};

export default React.memo(ChunkCard);
